import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import API from '../API';

const NOTIFICATIONS_KEY = ['_getEnquiryNotifications'];

const fetchEnquiryNotifications = async () => {
  const response = await API.get('/project-panel/enquiry-notifications/get-all');
  return response.data?.data || { data: [], counts: { total: 0 } };
};

export const useGetEnquiryNotifications = () =>
  useQuery(NOTIFICATIONS_KEY, fetchEnquiryNotifications, {
    refetchInterval: 30000,
    refetchOnWindowFocus: true,
  });

export const useMarkEnquiryNotificationsSeen = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (slug) => API.put('/project-panel/enquiry-notifications/mark-seen', { slug }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(NOTIFICATIONS_KEY);
      },
    }
  );
};
